<template>
  <div v-if="isContent" id="TachoMonitoringContent" class="card shadow content">
    <div class="card-header text-bg-danger d-flex justify-content-between align-items-center">
      <strong>개인택시 운행경로조회</strong>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col">
          <SearchBarPrivate
            :secondaryStyle="true"
            :onSubmitPrivate="handleSearchSubmit"
          />
        </div>
      </div>
      <div class="card-body" v-if="showgraph" style="background-color:white;  position: fixed; bottom:15px; left:750px; width: 600px; height:220px">
        <VueApexDetailTable title="속도(km/h)" y-title="속도(km/h)" :values="velocity" :mapTarget="mapTarget"></VueApexDetailTable>
      </div>
      <AccordianComponent :item="summary" class="my-5"/>

      <div class="d-flex justify-contents-between w-100">
        <div class="d-flex w-50">
          <p class="my-auto">총 <strong class="total-text">{{ totalData }}</strong>건</p>
        </div>
        <div class="d-flex w-100">
          <p class="my-auto">페이지 경로표시</p>
          <div class="my-auto form-check form-switch ps-10">
            <input class="form-check-input" type="checkbox" role="switch" @change="changeFormValue($event,'path')"
                   checked>
          </div>
        </div>
        <form id="route-form" class="d-flex justify-content-end w-50">
          <button type="button" id="route-all-button" class="btn btn-primary btn-sm p-1 m-1" @click="setSales">전체
          </button>
          <button type="button" id="route-enable-button" class="btn btn-secondary btn-sm p-1 m-1" @click="setSales">영업
          </button>
          <button type="button" id="route-disable-button" class="btn btn-secondary btn-sm p-1 m-1" @click="setSales">
            주행
          </button>
        </form>
      </div>
      <div class="my-wrapper" style="overflow:auto;"  @click="detectClick($event)">
        <kona-table :fields="fieldNames" :elements="elements" :allData="allData" :sales="sales" style="font-size: 13px" class="hover-event"
                    ref="kona_table" @scroll="insertData" :pageInfo="pageInfo" :onSelected="onSelected" :selectColor="'#B2EBF4'"/>
      </div>
    </div>

    <div class="collapse-box">
      <div class="collapse-btn shadow" @click="hideContent();setSmallSideBar()">
        <BIconChevronLeft :fill="SKY_BLUE"/>
      </div>
    </div>

  </div>

  <ReciptModal v-if="createModalOpen" :recipt="receipt" @close="createModalOpen = false"  />

  <template v-if="!isContent">
    <img id='header-collapse-btn' :class="isSmallHeader && 'without-header'" src="favicon.ico" @click="handleCollapse"/>
  </template>

</template>

<script setup>
import {computed, getCurrentInstance, onMounted, onUnmounted, ref} from 'vue';
import {useStore} from 'vuex';
import axios from '@/composables/Axios';
import {checkLocation, checkLocationXY, getAzimuth} from '@/composables/Functional';
import Entity from '@/entity/MonitoringEntity';
import {
  changeFormat, dateFormatFunc,
  dateFormatFuncForExcel,
  dateMinusNday,
  dateMinusNsecond,
  datePlus1day,
  endDateInit,
  endMaxDateInit,
  insertComma, makeDataTableFields,
  meterToKilo,
  secToHourMinute,
  secToMinute,
  startDateInit, startDateSetSecond, viewYN
} from "@/components/tacho/common/CommonFunc"
import {DARK_GRAY, PRIMARY_RED, SKY_BLUE, RED} from '@/styles/colors';
import OperationEntity from '@/entity/OperationEntity'
import AccordianComponent from '@/components/monitoring/tacho/components/AccordianComponent.vue'
import {BIconChevronLeft, BIconArrowCounterclockwise,BIconSearch} from "bootstrap-icons-vue";
import {
  routeArrow,
  routeEndBk,
  routeEndBkBg,
  routeEndRed,
  routeEndRedBg,
  routeStartBk,
  routeStartBkBg,
  routeStartRed,
  routeStartRedBg
} from '@/composables/file';
import tachoEntity from "@/entity/TachoEntity";
import dayjs from "dayjs";
import {VueApexDetailTable} from "@/components/tacho/chart";
import CarNumWithSearchInput from "@/components/tacho/searchbar/CarNumWithSearchInput.vue";
import {ReciptModal} from "@/components/tacho/modal";
import SearchBarCorp from "@/components/tacho/SearchBarCorp.vue";
import SearchBarPrivate from "@/components/tacho/SearchBarPrivate.vue";

const {proxy} = getCurrentInstance();
let receipt = ref();
const store = useStore(),
    url = store.state.api.tacho,
    setLoading = (value) => store.commit('setLoading', value),
    isContent = computed(() => store.state.content.isContent),
    isSmallHeader = computed(() => store.state.content.isSmallHeader),
    showContent = () => store.commit('content/showContent'),
    hideContent = () => store.commit('content/hideContent'),
    setSmallSideBar = () => store.commit('content/setSmallSideBar'),
    smallHeader = () => store.commit('content/smallHeader'),
    fullHeader = () => store.commit('content/fullHeader'),
    moveCenter = (value) => store.dispatch('kakaoMap/moveCenter', value),
    kakaoSrc = store.state.kakaoMap.src;

const queryParam = new tachoEntity.drivingSearchDto();
const mapTarget=ref("-1");
let marker;
let viewYn = viewYN(store.state.sign['userInfo'].viewYN)
let infoWindow = "";
let velocitywithdist = ref([]);
let resAmount = ref(0);

const elements = ref([]),
    sales = ref(undefined),
    summary = ref({
      emptyDist: 0,
      emptyTime: 0,
      hipassFare: 0,
      extraFare: 0,
      fare: 0,
      onDist: 0,
      onTime: 0,
      totalTime: 0,
      totalDist: 0,
      totalFare: 0,
      callFare:0
    });

let tachoPolyLines = [],
    tachoCustomOverlays = [],
    tachoIndex = 0;

const fieldNames = [
  {key: "start", label: "시작"},
  {key: "end", label: "종료"},
  {key: "time", label: "시간"},
  {key: "distance", label: "거리"},
  {key: "amount", label: "금액"},
  {key: "type", label: "타입"},
  {key: "employee", label: "사번"}
];

const lastSearchParams = ref(null);
const lastClickEvent = ref(null);
const createModalOpen = ref(false);
const allData = ref([]),
    tempArr = ref([]),
    kona_table = ref();
let totalData = 0;
const pagePath = ref(true);
let routesList = [];
const pageInfo = ref({
  totalElements: 0,
  totalPages: 1,
  currentPage: 1
});
let velocity = ref([]);

const init = () => {
  marker = new kakao.maps.Marker({
    position:  new kakao.maps.LatLng(37.54699, 127.09598)
  });
};

onMounted(() => {
  if (window.kakao && window.kakao.maps) {
    init();
  } else {
    let script = document.createElement("script");
    script.onload = () => kakao.maps.load(init);
    script.src = kakaoSrc;
    document.head.appendChild(script);
  }
});
onUnmounted(() => erasePath());
const openCreateModal = () => {
  if (lastClickEvent.value === 4) {
    createModalOpen.value = true;
  }
}
const showContentHeader = () => {
  showContent();
  fullHeader();
}

const handleCollapse = () => {
  if (!isSmallHeader.value) {
    smallHeader();
    setSmallSideBar();
  } else {
    showContentHeader();
  }
}
const detectClick = (event) => {
  const td = event.target.closest("td");
  if (!td) return;
  lastClickEvent.value = td.cellIndex;
}
const entity = new OperationEntity.organizationHeaders(store.state.sign['userInfo'].userId, "traceId");
const headers = entity.get();
const changeFormValue = async (event, name) => {
  switch (name) {
    case "path": {
      if (pagePath.value) {
        pagePath.value = false

        if (routesList.data !== undefined) {
          elements.value = routesList.data.data
          await clickSearchBtn()
        }

      } else {
        pagePath.value = true

        if (allData.value.length > 0) {
          elements.value = allData.value[0]
          if (lastSearchParams.value !== null) {
            await clickSearchBtn()
          }
        }
      }
      break;
    }
  }
}

const division = (arr, n) => {
  const length = arr.length;
  const divide = Math.floor(length / n) + (Math.floor(length % n) > 0 ? 1 : 0);
  const newArray = [];

  for (let i = 0; i <= divide; i++) {
    // 배열 0부터 n개씩 잘라 새 배열에 넣기
    newArray.push(arr.splice(0, n));
  }
  return newArray;
}

const clickSearchBtn = async (page = 1, size = 10) => {

  if (marker) {
    marker.setMap(null);
  }
  if (infoWindow !== "") {
    infoWindow.setMap(null);
  }
  mapTarget.value = "-1";
  showgraph.value = false;

  const startHour = changeFormat(lastSearchParams.value.fromDtti, 'HH');
  const startYYYYMMDD = changeFormat(lastSearchParams.value.fromDtti, 'YYYY-MM-DD');
  const endHour = changeFormat(lastSearchParams.value.untilDtti, 'HH');
  const endYYYYMMDD = changeFormat(lastSearchParams.value.untilDtti, 'YYYY-MM-DD');

  showgraph.value = false;

  const startIso = changeFormat(startYYYYMMDD, `YYYY-MM-DDT${startHour}:00:00`);
  const endIso = changeFormat(endYYYYMMDD, `YYYY-MM-DDT${endHour}:00:00`);

  elements.value = [];

  const entity = new Entity.DrivingRoute(
      "",
      lastSearchParams.value.carNum,
      "",
      "",
      "",
      page - 1,
      size,
      lastSearchParams.value.fromDtti,
      lastSearchParams.value.untilDtti,
      0,
      viewYn
  );

  if (sales.value === undefined) {
    entity.routeType = 0
  } else if (sales.value === true) {
    entity.routeType = 1
  } else {
    entity.routeType = 2
  }

  const params = entity.get();
  store.state.searchForms = params;

  try {
    setLoading(true);

    const res = await axios.$get(url + `driving/route`, {params: params}, headers);
    elements.value = [];

    pageInfo.value.totalPages = res.data.data.totalPages;
    pageInfo.value.totalElements = res.data.data.totalElements;
    pageInfo.value.currentPage = page;

    const resSummary = await axios.$get(url + 'driving/route/summary', {params: params}, headers);
    summary.value = {
      emptyDist: meterToKilo(resSummary.data.data.summaryDriving.allBlankDist).toFixed(2),
      emptyTime: secToMinute(resSummary.data.data.summaryDriving.allBlankTime),
      hipassFare: insertComma(resSummary.data.data.summaryDriving.allHipassFare),
      callFare: insertComma(resSummary.data.data.summaryDriving.allCallFare),
      extraFare: insertComma(resSummary.data.data.summaryDriving.allAddFare),
      fare: insertComma(resSummary.data.data.summaryDriving.allPayFare),
      onDist: meterToKilo(resSummary.data.data.summaryDriving.allWorkDist),
      onTime: secToMinute(resSummary.data.data.summaryDriving.allWorkTime),
      totalTime: secToMinute(resSummary.data.data.summaryDriving.allWorkTime + resSummary.data.data.summaryDriving.allBlankTime),
      totalDist: meterToKilo(resSummary.data.data.summaryDriving.allWorkDist + resSummary.data.data.summaryDriving.allBlankDist).toFixed(2),
      totalFare: insertComma(
          resSummary.data.data.summaryDriving.allPayFare
          + resSummary.data.data.summaryDriving.allAddFare
          + resSummary.data.data.summaryDriving.allHipassFare
          + resSummary.data.data.summaryDriving.allCallFare
      )
    };

    const getRoutesList = await axios.$get(url + 'driving/route/location/individual/all', {params: params}, headers);
    if (getRoutesList.data.data.length > 0) routesList = getRoutesList;
    totalData = 0;

    //실데이터
    res.data.data.content.forEach(element => {
      const is = element.routeType === 'WORK';
      let locationArray = [];
      const filteredRoutes = routesList.data.data.filter(v => v.newKey === element.newKey);
      let locations = filteredRoutes.length > 0
          ? filteredRoutes[0].locations
          : [];
      for (const location of locations) {
        if ((location.carX !== null && location.carY !== null) && (location.carX > 0 && location.carY > 0)) {
          locationArray.push({lat: location.carX, lng: location.carY});
        }
      }

      tempArr.value.push({
        minDtti:element.minDtti,
        maxDtti:element.maxDtti,
        start: dateFormatFuncForExcel(element.minDtti, 'HH:mm'),
        end: dateFormatFuncForExcel(element.maxDtti, 'HH:mm'),
        time: secToHourMinute(element.workTime),
        distance: meterToKilo(element.workDist).toFixed(1),
        amount: insertComma(element.fare),
        type: element.payType,
        employee: element.driverId,
        location: locationArray,
        is: is
      })
      totalData += 1;
    });

    if (tempArr.value.length > 0) {
      allData.value = division(tempArr.value, 10);
      elements.value = allData.value[0];
    }

    if (pagePath.value === true)
      drawPath(elements.value)
    else
      drawAllPath(routesList.data.data)

    kona_table.value.initPageIndex();

    for (let i = 0; i < tachoPolyLines.length; i++ ){
      for (let j=0 ;j< tachoPolyLines[i].length; j++ ){
        kakao.maps.event.addListener(tachoPolyLines[i][j],'click',function (e){
          onSelected(i);
        })
      }
    }

  } catch (error) {
    store.commit('openMessageBox', error);
  } finally {
    setLoading(false);
  }
}

const routeMarkerArrow = (azimuth) => {
  return `<div class="overlay-box">
            <img src="${routeArrow}" style="position: fixed; width: 15px; height: 15px; transform: rotate(${azimuth}deg);">
            </div>`;
}

const routeMarkerSingle = (text, isWork) => {
  if (text === 'S') {
    return `<div class="overlay-box">
              <img src="${isWork ? routeStartRed : routeStartBk}" style="position: fixed; width: 33px; height: 33px;">
              </div>`;
  } else if (text === 'E') {
    return `<div class="overlay-box">
              <img src="${isWork ? routeEndRed : routeEndBk}" style="position: fixed; width: 33px; height: 33px;">
              </div>`;
  }
  return '';
}

const routeMarkerMulti = (text, isWork, count) => {
  if (text === 'S') {
    return `<div class="overlay-box">
              <img src="${isWork ? routeStartRedBg : routeStartBkBg}" style="position: fixed; width: 33px; height: 33px;">
                <div class="overlay-text text-black" >
                    ${count}
                </div>
              </div>`
  } else if (text === 'E') {
    return `<div class="overlay-box">
              <img src="${isWork ? routeEndRedBg : routeEndBkBg}" style="position: fixed; width: 33px; height: 33px;">
              </div>`
  }
  return '';
}
const showgraph=ref(false);
const drawPath = (elements) => {

  erasePath();
  if (elements === undefined) return;
  if (elements.length <= 0) return;
  mapTarget.value = "-1";
  /*
    그림 그리기
    element안에 location 배열을 돌면서
    한번의 운전이 공차 아니면 실차
  */

  for (let i = 0; i < elements.length; i++) tachoPolyLines.push([])

  for (let i = 0; i < elements.length; i++) {
    if (sales.value !== undefined && elements[i].is !== sales.value) continue;

    if (elements[i].location.length < 2) continue;

    for (let j = 1; j < elements[i].location.length; j++) {
      if (!checkLocation(elements[i].location[j]) || !checkLocation(elements[i].location[j - 1])) continue;
      tachoPolyLines[i].push(new kakao.maps.Polyline({
        map: window.kakaoMap,
        path: [
          new kakao.maps.LatLng(elements[i].location[j - 1].lat, elements[i].location[j - 1].lng),
          new kakao.maps.LatLng(elements[i].location[j].lat, elements[i].location[j].lng),
        ],
        strokeWeight: 8,
        strokeColor: elements[i].is ? PRIMARY_RED : DARK_GRAY,
        strokeOpacity: 0.5,
        strokeStyle: 'solid'
      }));

      if (j < elements[i].location.length - 1) {
        let azimuth = getAzimuth(elements[i].location[j], elements[i].location[j + 1]);
        tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
          map: window.kakaoMap,
          opacity: 0.5,
          content: routeMarkerArrow(azimuth),
          position: new kakao.maps.LatLng(elements[i].location[j].lat, elements[i].location[j].lng)
        }));
      }
    }

    //숫자 디자인
    let text = ++tachoIndex;

    if (elements.length === 1) {
      tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
        map: window.kakaoMap,
        opacity: 0.5,
        content: routeMarkerSingle("S", elements[i].is),
        position: new kakao.maps.LatLng(elements[i].location[0].lat, elements[i].location[0].lng)
      }));

      tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
        map: window.kakaoMap,
        opacity: 0.5,
        content: routeMarkerSingle("E", elements[i].is),
        position: new kakao.maps.LatLng(elements[i].location[elements[i].location.length - 1].lat, elements[i].location[elements[i].location.length - 1].lng)
      }));
    } else {
      tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
        map: window.kakaoMap,
        opacity: 0.5,
        content: routeMarkerMulti("S", elements[i].is, text),
        position: new kakao.maps.LatLng(elements[i].location[0].lat, elements[i].location[0].lng)
      }));

      tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
        map: window.kakaoMap,
        opacity: 0.5,
        content: routeMarkerMulti("E", elements[i].is, text),
        position: new kakao.maps.LatLng(elements[i].location[elements[i].location.length - 1].lat, elements[i].location[elements[i].location.length - 1].lng)
      }));
    }
  }

  for (let i = 0; i < elements.length; i++) {
    if (elements[i].location.length > 0) {
      moveCenter(elements[i].location[0]);
      break;
    }
  }
  for (let i = 0; i < tachoPolyLines.length; i++) {
    for (let j = 0; j < tachoPolyLines[i].length; j++) {
      kakao.maps.event.addListener(tachoPolyLines[i][j], 'click', function (e) {
        if (velocitywithdist.value[j] != undefined)
        {
          mapTarget.value=j+"";
          if (marker) marker.setMap(null);
          if (infoWindow != "") {
            infoWindow.setMap(null);
          }
          let iwContent = "";
          let timeText = " 발생 시간 : " + dateFormatFunc(velocitywithdist.value[j][0], `YYYY-MM-DD HH:mm:ss`) ;
          let sppedText = " 속도 : " + velocitywithdist.value[j][1] + "km/h" ;
          let distanceText = " 주행거리 : " + (parseInt(velocitywithdist.value[j][2])/1000)  + "km";
          let amount = "운임요금 : " + resAmount.value + "원 " ;
          iwContent = '<div style="width:250px;height: 100px; border:2px solid #3c92ff"  >'+ timeText + '<br>' + sppedText + '<br>' + distanceText +'<br>' + amount + '</div>' ; // 인포윈도우에 표출될 내용으로 HTML 문자열이나 document element가 가능합니다
          infoWindow = new kakao.maps.InfoWindow({
            position: e.latLng,
            content: iwContent,
            zIndex: 100
          });
        }
        marker = new kakao.maps.Marker({
          position: e.latLng
        });
        marker.setMap(window.kakaoMap);
        window.kakaoMap.setCenter(e.latLng);
        if (infoWindow != "") {
          infoWindow.open(window.kakaoMap, marker);
        }

      })

    }
  }
}

const drawAllPath = (elements) => {
  if (elements === undefined) return;
  erasePath();

  if (marker) marker.setMap(null);
  if (infoWindow != "") {
    infoWindow.setMap(null);
  }

  if (elements.size <= 0) return;

  /*
    그림 그리기
    element안에 location 배열을 돌면서
    한번의 운전이 공차 아니면 실차
  */

  for (let i = 0; i < elements.length; i++) tachoPolyLines.push([])
  for (let i = 0; i < elements.length; i++) {
    elements[i].is = elements[i].routeType === 'WORK';
    if (sales.value !== undefined && elements[i].is !== sales.value) continue;
    if (elements[i].locations.length < 2) continue;

    for (let j = 1; j < elements[i].locations.length; j++) {
      if (!checkLocationXY(elements[i].locations[j]) || !checkLocationXY(elements[i].locations[j - 1])) continue;
      tachoPolyLines[i].push(new kakao.maps.Polyline({
        map: window.kakaoMap,
        path: [
          new kakao.maps.LatLng(elements[i].locations[j - 1].carX, elements[i].locations[j - 1].carY),
          new kakao.maps.LatLng(elements[i].locations[j].carX, elements[i].locations[j].carY),
        ],
        strokeWeight: 8,
        strokeColor: elements[i].is ? PRIMARY_RED : DARK_GRAY,
        strokeOpacity: 0.5,
        strokeStyle: 'solid'
      }));

      if (j < elements[i].locations.length - 1) {
        let azimuth = getAzimuth(elements[i].locations[j], elements[i].locations[j + 1]);
        tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
          map: window.kakaoMap,
          opacity: 0.5,
          content: routeMarkerArrow(azimuth),
          position: new kakao.maps.LatLng(elements[i].locations[j].carX, elements[i].locations[j].carY)
        }));
      }
    }

    //숫자 디자인
    let text = ++tachoIndex;

    if (elements.length === 1) {
      tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
        map: window.kakaoMap,
        opacity: 0.5,
        content: routeMarkerSingle("S", elements[i].is),
        position: new kakao.maps.LatLng(elements[i].locations[0].carX, elements[i].locations[0].carY)
      }));

      tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
        map: window.kakaoMap,
        opacity: 0.5,
        content: routeMarkerSingle("E", elements[i].is),
        position: new kakao.maps.LatLng(elements[i].locations[elements[i].locations.length - 1].carX, elements[i].locations[elements[i].locations.length - 1].carY)
      }));
    } else {
      tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
        map: window.kakaoMap,
        opacity: 0.5,
        content: routeMarkerMulti("S", elements[i].is, text),
        position: new kakao.maps.LatLng(elements[i].locations[0].carX, elements[i].locations[0].carY)
      }));

      tachoCustomOverlays.push(new kakao.maps.CustomOverlay({
        map: window.kakaoMap,
        opacity: 0.5,
        content: routeMarkerMulti("E", elements[i].is, text),
        position: new kakao.maps.LatLng(elements[i].locations[elements[i].locations.length - 1].carX, elements[i].locations[elements[i].locations.length - 1].carY)
      }));
    }
  }

  for (let i = 0; i < elements.length; i++) {
    if (elements[i].locations.length > 0) {
      moveCenter(elements[i].locations[0]);
      break;
    }
  }
}
const erasePath = () => {
  for (let i in tachoPolyLines)
    for (let j in tachoPolyLines[i])
      tachoPolyLines[i][j].setMap(null);

  tachoPolyLines = [];
  for (let index in tachoCustomOverlays) tachoCustomOverlays[index].setMap(null);
  tachoCustomOverlays = [];

  tachoIndex = 0;
}

const setSales = (object) => {
  const forms = document.getElementById("route-form")
  for (let i = 0; i < forms.length; i++) {
    forms[i].className = forms[i].className.replace('primary', 'secondary')
  }

  if (object.target.id === 'route-disable-button') sales.value = false;
  else if (object.target.id === 'route-enable-button') sales.value = true;
  else if (object.target.id === 'route-all-button') sales.value = undefined;

  object.target.className = object.target.className.replace('secondary', 'primary');

  clickSearchBtn()
}

const insertData = (pageIndex) => {
  clickSearchBtn(pageIndex);
}

const onSelected = (index) => {
  resAmount.value = allData.value[0][index].amount;
  const searchData = store.state.searchForms;
  if (marker) marker.setMap(null);
  if (infoWindow != "") {
    infoWindow.setMap(null);
  }

  if (searchData) {
    queryParam.startDate = elements.value[index].minDtti;
    queryParam.endDate = elements.value[index].maxDtti;
    queryParam.carNum = searchData.carNum;
    const speedDist = axios.$get(`${url}driving/graph/speed-dist/individual`, {params: queryParam}, entity.get());
    speedDist.then((response) => {
      setVelocity(response.data.data);
      showgraph.value = true;
      drawPath([elements.value[index]]);
    });
  }
  const receiptReq = {
    officeId: searchData.officeId,
    driverId: searchData.driverId,
    carNum: searchData.carNum,
    stDtti: elements.value[index].minDtti,

  };
  const onReceipt = axios.$get(`${url}trips/one`, {params: receiptReq}, entity.get());
  onReceipt.then((response) => {
    receipt.value = response.data.data ;
    openCreateModal();
  })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          console.error("운행이 존재하지 않습니다.");
        } else {
          console.error("기타 에러:", error);
        }
      });


}

const covertGMT9 = (datas) => {
  for (let i = 0; i < datas.length; i++) {
    datas[i][0] = dayjs(datas[i][0]).add(9, 'hour').$d.getTime();

  }
  return datas;
}
const covertGMT = (datas) => {
  for (let i = 0; i < datas.length; i++) {
    datas[i][0] = dayjs(datas[i][0]).$d.getTime();
  }
  return datas;
}
const setVelocity = (ls) => {
  if (velocity.value.length > 0) {
    velocity.value = [];
    velocitywithdist.value = [];
  }
  ls.map(v => {
    velocity.value.push([v.infoDtti, v.speed]);
    velocitywithdist.value.push([v.infoDtti, v.speed,v.dist]);
  })
  velocity.value = covertGMT9(velocity.value);
  velocitywithdist.value = covertGMT(velocitywithdist.value);
}

function handleSearchSubmit(params) {
  lastSearchParams.value = params;
  clickSearchBtn();
}
</script>

<style scoped>
*:not(svg) {
  font-size: 0.8rem;
}

#TachoMonitoringContent {
  width: 80%;
  /* height: 105%; */
  height: 100%;
}

.form-label {
  font-size: 12px;
}

button {
  color: white;
  font-weight: 600;
}

.total-text {
  color: rgb(72, 155, 249)
}

.text-bg-danger {
  background-color: v-bind(RED) !important;
}

.card-body {
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100% - 24rem);
}

.card-header {
  padding-right: 8px;
}

.showContentBtn > *,
.smallHeaderBtn > *,
.allBtn > * {
  font-size: 16px !important;
}

.content {
  position: relative;
}

.collapse-box {
  position: absolute;
  display: flex;
  align-items: center;

  top: 0;
  right: -1rem;
  height: 100%;
}

.collapse-btn {
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: white;
  border-radius: 1rem;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  z-index: 250;
  pointer-events: all;
}

#header-collapse-btn {
  position: absolute;
  top: 0.6rem;
  left: 1.7rem;
  width: 1.2rem;
  height: 1.2rem;
  z-index: 400;
  cursor: pointer;
}
</style>

<style>
.overlay-box {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none
}

.overlay-text {
  text-align: center;
  font-weight: bold;
  font-size: 0.5rem !important;
  z-index: 10;
  padding-bottom: 3px;
}

.my-wrapper .hover-event tr td:nth-child(5) {
  cursor: pointer;
  color: blue;
}
</style>
